/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMinervalGridDto } from './FcbMinervalGridDto';
import {
    FcbMinervalGridDtoFromJSON,
    FcbMinervalGridDtoFromJSONTyped,
    FcbMinervalGridDtoToJSON,
} from './FcbMinervalGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMinervalGridDtoPaginatedResults
 */
export interface FcbMinervalGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMinervalGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMinervalGridDto>}
     * @memberof FcbMinervalGridDtoPaginatedResults
     */
    results?: Array<FcbMinervalGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMinervalGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMinervalGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMinervalGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMinervalGridDtoPaginatedResultsFromJSON(json: any): FcbMinervalGridDtoPaginatedResults {
    return FcbMinervalGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMinervalGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMinervalGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMinervalGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMinervalGridDtoPaginatedResultsToJSON(value?: FcbMinervalGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMinervalGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

